<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <a href="/">
        <base-img
          :src="require('@/assets/logo.png')"
          contain
          max-width="140"
          width="100%"
      /></a>

      <v-spacer />

      <div>
        <v-tabs class="hidden-sm-and-down" optional>
          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/"
            text
          >
            Home
          </v-tab>

          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/about-us"
            text
          >
            About
          </v-tab>

          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/vessel-it-support"
            text
          >
            Vessel IT
          </v-tab>

          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/solutions"
            text
          >
            Solutions
          </v-tab>

          <!-- <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Services
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-tab class="text-left text-caption" to="/consultancy"
                  >Cyber Security
                  <v-list>
                  <v-list-item>
                    <v-tab class="text-left text-caption" to="/consultancy"
                      >Cyber Security
                    </v-tab>
                  </v-list-item>
                </v-list>
                </v-tab>
                
              </v-list-item>
              <v-list-item>
                <v-tab class="text-left text-caption" to="/consultancy"
                  >ERP Services
                </v-tab>
              </v-list-item>
            </v-list>
          </v-menu> -->

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Services
              </v-tab>
            </template>
            <v-list>
              <!-- Cyber Security -->
              <v-menu offset-y v-model="ReadySolutionsSubMenu">
                <template v-slot:activator="{}">
                  <v-list-item v-on="on">
                    <v-tab class="text-left text-caption" to="/solutions"
                      >Ready Solutions
                    </v-tab>
                  </v-list-item>
                </template>
              </v-menu>

              <v-menu offset-y v-model="ReadySolutionsSubMenu">
                <template v-slot:activator="{}">
                  <v-list-item v-on="on">
                    <v-tab
                      class="text-left text-caption"
                      to="/managed-cloud-services"
                      >Managed Cloud Services
                    </v-tab>
                  </v-list-item>
                </template>
              </v-menu>

              <v-menu offset-y v-model="cyberSecuritySubMenu">
                <template v-slot:activator="{ on }">
                  <v-list-item v-on="on">
                    <v-tab class="text-left text-caption">Cyber Security</v-tab>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item>
                    <v-tab class="text-left text-caption" to="/consultancy"
                      >Consultancy
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      to="/security-operation-center-for-maritime-industry"
                      class="text-left text-caption"
                    >
                      TM/Security Operations Centre(SOC)
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/cyber-security-awareness-assessment-system"
                    >
                      Training
                    </v-tab>
                  </v-list-item>
                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/database-security-audit"
                    >
                      Database Audit
                    </v-tab>
                  </v-list-item>
                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/azure-cybersecurity-audit-services-for-maritime"
                    >
                      Azure Cloud Audit
                    </v-tab>
                  </v-list-item>

                  <!-- Add more subservice items if needed -->
                </v-list>
              </v-menu>

              <!-- ERP Services -->
              <v-menu offset-y v-model="erpServicesSubMenu">
                <template v-slot:activator="{ on }">
                  <v-list-item v-on="on">
                    <v-tab class="text-left text-caption">ERP Services</v-tab>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/netsuite-erp-services-for-the-maritime-industry"
                    >
                      NetSuite OneWorld
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/netsuite-integration-services-for-the-maritime-industry"
                    >
                      NetSuite Integration
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/netsuite-ai-powered-financial-assistant"
                    >
                      NetSuite AI Powered Financial Assistant
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/financial-data-integration"
                    >
                      Financial Data Integration
                    </v-tab>
                  </v-list-item>

                  <v-list-item>
                    <v-tab
                      class="text-left text-caption"
                      to="/power-bi-connector-for-netsuite"
                    >
                      Power BI Connector for NetSuite
                    </v-tab>
                  </v-list-item>
                  <!-- Add more subservice items if needed -->
                </v-list>
                <!-- Define ERP Services Subservice here if needed -->
              </v-menu>
              <!-- Add more main service items if needed -->
            </v-list>
          </v-menu>

          <!-- <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Cyber Security
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-tab class="text-left text-caption" to="/consultancy"
                  >Consultancy
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  to="/security-operation-center-for-maritime-industry"
                  class="text-left text-caption"
                >
                  TM/Security Operations Centre(SOC)
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/cyber-security-awareness-assessment-system"
                >
                  Training
                </v-tab>
              </v-list-item>
              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/database-security-audit"
                >
                  Database Audit
                </v-tab>
              </v-list-item>
              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/azure-cybersecurity-audit-services-for-maritime"
                >
                  Azure Cloud Audit
                </v-tab>
              </v-list-item>
            </v-list>
          </v-menu> -->

          <!-- <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                ERP Services
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/netsuite-erp-services-for-the-maritime-industry"
                >
                  NetSuite OneWorld
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/netsuite-integration-services-for-the-maritime-industry"
                >
                  NetSuite Integration
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/netsuite-ai-powered-financial-assistant"
                >
                  NetSuite AI Powered Financial Assistant
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/financial-data-integration"
                >
                  Financial Data Integration
                </v-tab>
              </v-list-item>

              <v-list-item>
                <v-tab
                  class="text-left text-caption"
                  to="/power-bi-connector-for-netsuite"
                >
                  Power BI Connector for NetSuite
                </v-tab>
              </v-list-item>
            </v-list>
          </v-menu> -->

          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/partners"
            text
          >
            Partners
          </v-tab>

          <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            to="/contact-us"
            text
          >
            Contact
          </v-tab>
          <!-- <v-tab
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            :to="'/:blog'+route"
            text
          >
            Blog
          </v-tab> -->
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer">
      </v-app-bar-nav-icon>
      <base-btn
        dark
        v-bind:to="'/demo' + '/' + routePath + '/kaits'"
        id="bookNow"
        target="_blank"
        color="blue darken-2"
      >
        Book Demo
      </base-btn>
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",
  beforeRouteEnter(to, from, next) {
    console.log(to);
  },
  components: {
    HomeDrawer: () => import("./Drawer")
  },

  data: () => ({
    drawer: null,
    activeService: null,
    ReadySolutionsSubMenu: null,
    cyberSecuritySubMenu: false,
    erpServicesSubMenu: false,
    routePath: "",
    nombreRuta: "",
    items: [
      {
        name: "Home",
        to: "/"
      },

      {
        name: "Vessel IT",
        to: "/vessel-it-support"
      },

      {
        name: "Solutions",
        to: "/solutions"
      },

      {
        name: "Managed Cloud Services",
        to: "/managed-cloud-services"
      },

      {
        name: "About",
        to: "/about-us"
      },

      {
        name: "Consultancy",
        to: "/consultancy"
      },

      {
        name: "Security OperationCenter For MaritimeIndustry",
        to: "/security-operation-center-for-maritime-industry"
      },

      {
        name: "Database Security Audit",
        to: "/database-security-audit"
      },

      {
        name: "NetSuite Integration Services",
        to: "/netsuite-integration-services-for-the-maritime-industry"
      },

      {
        name: "NetSuite ERP Services",
        to: "/netsuite-erp-services-for-the-maritime-industry"
      },

      {
        name: "Partners",
        to: "/partners"
      },

      {
        name: "Financial Data Integration",
        to: "/financial-data-integration"
      },

      {
        name: "NetSuite AI Powered Financial Assistant",
        to: "/netsuite-ai-powered-financial-assistant"
      },

      {
        name: "Blog",
        to: "/blog"
      },

      {
        name: "Contact",
        to: "/contact-us"
      }
    ]
  }),
  mounted() {
    this.routePath = this.$router.currentRoute.name;
    console.log(this.routePath);

    this.route = "/importance-of-cyber-security";
    console.log(this.route);
    localStorage.setItem("import", this.route);
  },
  methods: {
    toggleSubService(service) {
      this.activeService = this.activeService === service ? null : service;
    },
    preventDropdownClose(event) {
      event.stopPropagation();
    }
  }
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 40px
    margin: 15px

    .v-tab
      &::before
        display: none
</style>
<style scoped>
@media only screen and (max-width: 600px) {
  #bookNow {
    display: none;
  }
}

.img {
  width: 10px;
  height: 10px;
}
</style>
